export default __webpack_public_path__ + "static/media/close-modal-icon.40d3201e.svg";